<ng-template #modalTemplate>
  <div class="modal-overlay" (click)="onOverlayClick($event)" (keydown)="$event.stopPropagation()" role="presentation">
    <div
      class="modal"
      [class.modal-lg]="size() === 'lg'"
      [class.modal-sm]="size() === 'sm'"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'modal-title'"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="modal-header">
        <h2 class="modal-title" id="modal-title" tabindex="-1">{{ title() }}</h2>
        @if (showCloseButton()) {
          <button mat-icon-button aria-label="Close dialog" (click)="closed.emit()">
            <app-icon name="close" size="20" />
          </button>
        }
      </div>

      <div class="modal-body">
        <ng-content />
      </div>

      @if (showFooter()) {
        <div class="modal-footer">
          @if (showCancel()) {
            <button mat-stroked-button (click)="closed.emit()">
              {{ cancelLabel() }}
            </button>
          }
          <button mat-flat-button [color]="confirmColor" [disabled]="confirmDisabled()" (click)="confirmed.emit()">
            {{ confirmLabel() }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
